import React from "react";
import {HeroInfoPage} from "../common/HeroInfoPage";

export const CravingsSupport = (props) => {
    return (
        <HeroInfoPage
            {...props}
            imageSrc="/static/image/questionnaire/fasting/cravings-support/cravings-happen-hero.png"
            title="Cravings happen - and that's totally fine"
            pageClassName="cravings-support-page"
        >
            <p className="hero-info-description">
                With the right plan, you'll <span className="hero-info-highlight">enjoy food</span> while building <span className="hero-info-highlight">healthy eating habits</span>.
            </p>
        </HeroInfoPage>
    );
};
